<template>
  <div class="s_bf p-l-24 p-r-24 p-t-20 m-t-10">
    <p class="fz-20 p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      {{$route.query.type == 'add'?'新建短信群发':'编辑短信群发'}}
    </p>
    <SmallSquare :content="'群发手机短信请保证有足够的短信条数，当前剩余短信条数：'+smsTotal+'条'" />
  </div>
  <a-card :bordered="false">
    
    <app-warp title='短信'>
      <template #app-title>
        <div class="app-sms-title">
          <LeftOutlined />
          <div>
            <a-avatar :size="30">
              <template #icon>
                <UserOutlined />
              </template>
            </a-avatar>
          </div>
        </div>
      </template>
      <template #app-content>
        <div class="app-sms-warp">
          <div class="app-sms-info">
            <p>短信/彩信</p>
            <p>今天 {{nowTime}}</p>
          </div>
          <div class="app-sms-content" v-html="form.content">
          </div>
        </div>
      </template>
      <template #app-sider>
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" style="margin-left:70px">
          <!-- 单选框 -->
          <a-form-item label="群发对象" name="send_type">
            <a-radio-group v-model:value="form.send_type" @change='sendTypeChange'>
              <a-radio :value="1">全部会员</a-radio>
              <a-radio :value="2">指定会员等级</a-radio>
              <a-radio :value="3">指定会员标签</a-radio>
              <a-radio :value="4">导入手机号</a-radio>
            </a-radio-group>
            <div class="m-t-10" v-if='form.send_type != 1'>
              <a-select v-model:value="form.source_id" :style="{width:'100%'}" mode="multiple" placeholder="请选择会员等级" v-if='form.send_type == 2' @change='selectChange' @blur='getNum' @deselect='getNum'>
                <a-select-option v-for='item in memberLevel' :key='item.vip_id' :value="item.vip_id">{{item.vip_name}}</a-select-option>
              </a-select>
              <a-select v-model:value="form.source_id" :style="{width:'100%'}" mode="multiple" placeholder="请选择会员标签" v-if='form.send_type == 3' @change='selectChange' @blur='getNum' @deselect='getNum'>
                <a-select-option v-for='item in memberTag' :key='item.id' :value="item.id">{{item.tag_name}}</a-select-option>
              </a-select>
              <div class="p-b-10" v-if='form.send_type == 4'>
                <a-button class="m-r-15"  type="primary" @click="downTemplate">
                  <template #icon><DownloadOutlined/></template>
                  下载模板
                </a-button>
                <a-upload v-model:fileList="fileList" :before-upload="handleChange">
                  <a-button>
                    <upload-outlined></upload-outlined>
                    导入Excel文件
                  </a-button>
                </a-upload>
              </div>
            </div>
            <p class="s_c999" v-if='form.send_type!=4'>当前人数{{nowPeople}}人</p>
          </a-form-item>
          <!-- tabs -->
          <a-form-item label="短信内容" name='content'>
            <a-button type="link" @click="templateVisible=true">选择模板</a-button>
            <a-textarea v-model:value="form.content" placeholder="显示短信模板内容" readonly :rows="4" />
          </a-form-item>
          <a-form-item label="短信签名" name=''>
            <span>【{{form.sign_name}}】</span>
          </a-form-item>
          <!-- 单选框 -->
          <a-form-item label="发送时间" name='send_time'>
            <a-radio-group v-model:value="form.send_time" @change="time=''">
              <a-radio :value="0">立即发送</a-radio>
              <a-radio :value="1">定时发送</a-radio>
            </a-radio-group>
            <div v-if='form.send_time==1'>
              <a-date-picker style="width:200px" showNow showTime v-model:value="time" valueFormat='YYYY-MM-DD HH:mm:ss' format='YYYY-MM-DD HH:mm:ss' placeholder='请选择发送时间' :disabled-date="disabledDate" />
            </div>
          </a-form-item>
          <!--  -->
          <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button @click="$router.go(-1)" class='m-r-20'> 取消 </a-button>
            <a-button type="primary" @click="onSubmit" class='m-r-10'> 确定 </a-button>
          </a-form-item>
        </a-form>
      </template>
    </app-warp>
  </a-card>
  <a-modal :keyboard="false" title="短信模板" centered v-model:visible="templateVisible" :footer="null" :width="1200"
    destroyOnClose>
    <smsTemplate @success="chooseTemplate" />
  </a-modal>
</template>
<script>
  import { reactive, toRefs, ref, inject,onMounted } from 'vue';
  import { getMemberTagList,getMemberVip } from '@/api/member';
  import { getSmsPhoneNum,setGroupAdd,setGroupEdit,getSignDetail,getSmsExcelFile,getSmsSurplus,getSmsGroupDetail } from '@/api/message';
  import { message, Modal } from 'ant-design-vue';
  import { UserOutlined, LeftOutlined,UploadOutlined,DownloadOutlined } from '@ant-design/icons-vue';
  import { iscode } from '@/utils/app';
  import smsTemplate from "./smsTemplate.vue";
  import { setDeliveryTemplate } from "@/api/order";
  import { json2fromData } from "@/utils/utils";
  let defForm = {
    send_type: 1,
    template_id: 5,
    content: '',
    source_id: [],
    file: '',
    send_time: 0
  }
  export default {
    components: { UserOutlined, LeftOutlined, smsTemplate,UploadOutlined,DownloadOutlined  },
    setup(props) {
      let send_type = async () => {
        if ((form.value.send_type == 2 || form.value.send_type == 3) && !form.value.source_id.length) {
          return Promise.reject("请选择群发对象");
        }else if (form.value.send_type == 4 && !state.fileList.length){
          return Promise.reject("请导入Excel文件");
        }else {
          return Promise.resolve();
        }
      };
      let send_time = async () => {
        if (form.value.send_time == 1 && !state.time) {
          return Promise.reject("请选择发送时间");
        } else if (testTime(state.time) < 10 && $route.query.type == 'add') {
          return Promise.reject('发送时间需要大于当前时间10分钟');
        } else {
          return Promise.resolve();
        }
      };
      const state = reactive({
        fileList:[],
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        memberLevel: [],//会员等级列表
        memberTag:[],//会员标签列表
        templateVisible: false, //短信模板是否显示
        nowTime:'0:00', //当前时间，页面手机显示使用
        time:'',
        smsTotal:0,//短信所剩数量
        nowPeople:0,//群发对象人数
        signature:'',
        rules: {
          send_type: [{ required: true, validator: send_type }],
          content: [
            { required: true, message: "请选择短信模板"},
          ],
          send_time: [{ required: true, validator: send_time }],
        },
      });
      const form = ref({ ...defForm });
      const $router = inject('$router');
      const $route = inject('$route');
      const momentTime=inject('momentTime')
      const disabledDate = (current) => {
        return current < momentTime().subtract(1, 'days')
      }
      // 选择模板
      const chooseTemplate = (data) => {
        state.templateVisible = false;
        form.value.content = data.content;
        form.value.template_id = data.id;
      };
      // 群发对象切换
      const sendTypeChange = (e) =>{
        form.value.source_id = [];
        state.fileList = [];
        state.nowPeople = 0;
        if(e.target.value == 1){
          getNum();
        }
      } 
      // 会员等级/标签选择
      const selectChange = (e) =>{
        form.value.source_id = e;
      } 
      // 获取等级
      const getLevel = async () => {
        let result = await getMemberVip().then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          state.memberLevel = result.data;
        }
      };
      // 获取标签
      const getTag = async () => {
        let result = await getMemberTagList({limit:99}).then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          state.memberTag = result.data.data;
        }
      };
       // 获取签名
       const getSignature = async () => {
        let result = await getSignDetail().then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          form.value.sign_name = result.data.sign
        }else {
          message.error(result.msg);
        }
      };
      // 获取发送数量
      const getNum = async () => {
        if(!form.value.source_id.length && form.value.send_type != 1){
          state.nowPeople = 0;
          return
        }
        let result = await getSmsPhoneNum({send_type:form.value.send_type,source_id:form.value.source_id}).then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          state.nowPeople = result.data.num
        }
      };
      //获取短信所剩数量
      const getSurplus = async () => {
        let result = await getSmsSurplus().then((res) => res.data).catch((error) => error);
        state.smsTotal = result.data.num;
      };
      //获取详情
      const getMore = async() =>{
        const hide = message.loading('正在加载中...', 0);
        let result = await getSmsGroupDetail($route.query.id).then((res) => res.data).catch((error) => error);
        if (iscode(result)) {
          form.value = result.data;
          var source_id = JSON.parse(result.data.source_id);
          form.value.source_id = source_id.map(v=>Number(v));
          state.time = momentTime(result.data.send_time*1000).format('YYYY-MM-DD HH:mm:ss');
          form.value.send_time = result.data.send_time == 0 ? 0 : 1;
          state.nowPeople = form.value.send_numbers;
        }else {
          message.error(result.msg);
        }
        setTimeout(hide);
      }
      // 判断时间
      const testTime = (time) => {
        var nowTime = momentTime().format()
        var startTime = momentTime(time)
        return startTime.diff(nowTime, 'minute')
      }
      // 保存
      const ruleForm = ref();
      const onSubmit = () => {
        ruleForm.value.validate().then(async (e) => {
          if(state.fileList.length > 1){
            message.error('只允许导入一个Excel文件！');
            return
          }
          if(state.smsTotal < state.nowPeople){
            message.error('当前短信剩余数不足以完成发送，请充值！');
            return
          }
          if(form.value.send_time == 1){
            form.value.send_time = state.time
          }
          const hide = message.loading('正在加载中...', 0);
          var formData = json2fromData({ ...form.value });
          let result 
          if($route.query.type == 'add'){
            result = await setGroupAdd(formData).then((res) => res.data).catch((error) => error);
          }else{
            result = await setGroupEdit(formData,$route.query.id).then((res) => res.data).catch((error) => error);
          }
          if (iscode(result)) {
            message.success(result.msg);
            setTimeout(() => {
              $router.go(-1);
            }, 1000);
          } else {
            message.error(result.msg);
          }
          setTimeout(hide);
        }).catch((error) => {
            message.error("请完善表单！"); });
      };

      // 下载模板
      const downTemplate = async () => {
        const hide = message.loading('正在加载中...', 0);
        let result = await getSmsExcelFile().then((res) => res.data).catch((error) => error);
        if (iscode(result, true)) {
          window.open(result.data.temp)
        }
        setTimeout(hide);
      };
      //选择文件
      const handleChange = (file) => {
        state.fileList = file;
        form.value.file = file;
        return false;
      }
      onMounted(() => {
        state.nowTime = momentTime().locale('zh-cn').format('HH:mm');
        getSurplus();
        getLevel();
        getTag();
        if($route.query.type == 'add'){
          getSignature();
          getNum();
        }else{
          getMore();
        }
      });
      return {
        ...toRefs(state),
        ruleForm,
        form,
        onSubmit,
        chooseTemplate,
        downTemplate,
        handleChange,
        sendTypeChange,
        selectChange,
        getNum,
        disabledDate
      };
    },
  };
</script>
<style lang="less" scoped>
  @import url('@/style/app-warp/app-warp.less');

  .ant-checkbox-wrapper {
    width: 500px;
  }

  .normal_map {
    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        margin-right: 10px;
        margin-bottom: 10px;

        // background: url(https://zx-oss.hebeigaoda.com/ydd_resource/20201113/e6933b585fea645a0180f2f24ed95c50.png)  ;
        label {
          width: 57px;
          height: 57px;
          display: block;
          border: 1px solid transparent;
        }

        input:checked~label {
          border: 1px solid #05486A;
        }
      }
    }
  }
</style>